import { DataTable } from '@/components/DataTable';
import type { TranslationKeys } from '@/lib/translations/types';

import { type CoverageRow, useColumns } from './useColumns';

interface Props {
  resources: CoverageRow[];
  from?: string;
  to?: string;
  showImpactType?: boolean;
  noResultsMessage?: TranslationKeys;
}

export const CoverageTable = ({
  resources,
  from,
  to,
  showImpactType = false,
  noResultsMessage,
}: Props): JSX.Element => {
  const columns = useColumns(from, to, showImpactType);

  return (
    <DataTable
      data={resources}
      columns={columns}
      headersTranslationPath="coverage.overview.table"
      optionsTranslationPaths={{
        impactZone: 'coverage.overview.table.impactZone.headerOptions',
        codeUrl: 'coverage.overview.table.codeUrl.headerOptions',
      }}
      initialSorting={[{ id: 'impactZone', desc: false }]}
      noResultsMessage={noResultsMessage}
    />
  );
};

export default CoverageTable;
